import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import MsLoader from './MsLoader';

const Loader = ({ size, theme, color }) => {
  const loaderColor = color || (theme && theme.loaderColor);
  const isEdge = /Edge/.test(navigator.userAgent);
  const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  if (isEdge || isIE11) {
    return <MsLoader size={size / 2} color={color} />;
  }

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={size}
      height={1.25 * size}
      viewBox="0 0 24 30"
      enableBackground="new 0 0 50 50"
    >
      <rect x="0" y="10" width="4" height="10" fill={loaderColor} opacity="0.2">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0s"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0s"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0s"
          dur="1.2s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="8" y="10" width="4" height="10" fill={loaderColor} opacity="0.2">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0.3s"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0.3s"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0.3s"
          dur="1.2s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="16" y="10" width="4" height="10" fill={loaderColor} opacity="0.2">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="0.2; 1; .2"
          begin="0.6s"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="height"
          attributeType="XML"
          values="10; 20; 10"
          begin="0.6s"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          attributeType="XML"
          values="10; 5; 10"
          begin="0.6s"
          dur="1.2s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  );
};

Loader.propTypes = {
  size: PropTypes.number,
  theme: PropTypes.object,
  color: PropTypes.string,
};

Loader.defaultProps = {
  size: 24,
  theme: {},
  color: '',
};

export default withTheme(Loader);
